define('model/template.object.attachment.model',['require','exports','module','./attachment.model'],function(require, exports, module) {
  var AttachmentModel = require('./attachment.model');

  var TemplateObjectAttachmentModel = AttachmentModel.extend({
    radioRequests: {
      'models TemplateObjectAttachmentModel': '@constructor',
    },

    urlRoot: AttachmentModel.urlTemplate(
      '/api/v1/compliance/disclosure/:parentAttachmentPoint/templateObject/:attachmentPoint/attachment'
    ),
  });

  module.exports = TemplateObjectAttachmentModel;
});

